<template>
  <div class="answer d-block">
    <v-radio-group
      :change="emitToParent()"
      v-model="selected"
      :class="$vuetify.breakpoint.mdAndUp ? 're-row' : ''"
    >
      <v-radio
        v-for="answer in answers"
        :key="answer._id"
        :value="answer._id"
        class="my-4"
      >
        <template v-slot:label v-if="answer.type === 'image'">
          <img
            :width="$vuetify.breakpoint.mdAndUp ? '' : '100%'"
            :src="
              'https://dl.pirls.ir/app/exams/' +
              questionId +
              '/' +
              answer._id +
              '.jpg'
            "
          />
        </template>
        <template v-slot:label v-else>
          <div class="text-h6 font-weight-bold text-justify ml-5">
            {{ answer.text }}
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: "question-answers-component",
  props: {
    questionId: { type: String, default: "" }
  },
  data() {
    return {
      answers: null,
      selected: ""
    };
  },
  created() {
    this.getAnswers();
  },
  methods: {
    getAnswers() {
      this.$api.get("/answers/" + this.questionId).then((res) => {
        this.answers = res.data.answers;
      });
    },
    emitToParent() {
      this.$emit("child-to-parent", this.selected);
    }
  }
};
</script>

<style>
.answer .re-row .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
}
</style>
